module.exports = __webpack_public_path__ + "static/thanks.312e0719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/thanks.svg
// module id = 740
// module chunks = 213534597649335